import { normalisePhoneUK } from './validators.js';
export function waLink(phone, message) {
    const p = normalisePhoneUK(phone ?? '');
    const text = message ? `?text=${encodeURIComponent(message)}` : '';
    return `https://wa.me/${p}${text}`;
}
export function smsLink(phone, message) {
    const p = (phone ?? '').replace(/\s+/g, '');
    const body = message ? `?body=${encodeURIComponent(message)}` : '';
    return `sms:${p}${body}`;
}
export function emailLink(email, subject, body) {
    const parts = [];
    if (subject)
        parts.push(`subject=${encodeURIComponent(subject)}`);
    if (body)
        parts.push(`body=${encodeURIComponent(body)}`);
    const qs = parts.length ? `?${parts.join('&')}` : '';
    return `mailto:${email}${qs}`;
}
export function telLink(phone) {
    const p = (phone ?? '').replace(/\s+/g, '');
    return `tel:${p}`;
}
export function postcodeMapLink(postcode) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(postcode)}`;
}
export function linkedInSearchFallback(firstName, lastName, company) {
    const q = `linkedin ${firstName} ${lastName} ${company ?? ''}`.trim();
    return `https://www.google.com/search?q=${encodeURIComponent(q)}`;
}
export function linkedInOrFallback(stored, firstName, lastName, company) {
    if (stored)
        return stored;
    return linkedInSearchFallback(firstName, lastName, company);
}
//# sourceMappingURL=links.js.map